<template>
  <div class="guides-page">
    <div class="guides-page__headline">
      <h1 class="h1--underline">
        {{ $tv('services.questionLabel', 'header') }}
      </h1>
    </div>
    <GuideList
      class="card__container container--guide guide-list"
      :guide-list="guides"
    />
    <div class="guides-page__line-container">
      <div class="guides-page__line-container__horizontal" />
    </div>
    <GuideCategoryList
      class="card__container container--guide"
      :guide-category-list="categories"
    />
  </div>
</template>
<script setup lang="ts">
import GuideList from '~/components/guide/GuideList.vue'
import GuideCategoryList from '~/components/guide/GuideCategoryList.vue'
import {useGuideService} from '~/composables/guide_service'
import useBreadcrumb from '~/composables/useBreadcrumb'
import useI18nExtended from '~/composables/usei18nExtended'

const {getGuidesList, getGuideCategories} = useGuideService()
const i18n = useI18nExtended()
const nuxtApp = useNuxtApp()
const guides = ref([])
const categories = ref([])

let guideList = nuxtApp.payload?.data[`guides_${i18n.locale.value}_0_-1_null_null_null_false`]
let categoriesLocal = (nuxtApp.payload?.data[`guides_${i18n.locale.value}_0_-1_null_null_{"field":"guide_categories.locale","operator":"eq","value":"${i18n.locale.value}"}_false`])?.map(g => g.guide_categories)?.flat()

if (categoriesLocal) {
  categoriesLocal = [...new Set(categoriesLocal?.map(s => s.id))]?.map(id => {return categoriesLocal?.find((r) => r.id === id)})
}
if (!guideList || !categoriesLocal) {
  [guideList, categoriesLocal] = await Promise.all([
    getGuidesList(i18n.locale.value),
    getGuideCategories(i18n.locale.value)
  ])
}

guides.value = guideList ? guideList.filter(g => g.IsTopGuide) : []
categories.value = categoriesLocal ?? []

useHead({
  meta: [{hid: 'robots', name: 'robots', content: 'noindex'}]
})

useBreadcrumb([
  {
    label: i18n.tv('guides', 'breadcrumbs'),
    path: '/guides'
  }
])
</script>

<style lang="scss">
.guides-page {
  background-color: $color__fst__blue__010;

  &__headline {
    background-color: $color__fst__white;
    padding-bottom: 1.2rem;
  }

  &__line-container {
    background-color: $color__fst__blue__010;
    padding: 0 2rem 1.375rem;

    &__horizontal {
      background-color: $color__fst__gray__030;
      height: 0.0625rem;
      margin: 0;
    }
  }

  .container--guide {
    background-color: $color__content--background__secondary;
  }

  h1 {
    margin: 0 2rem 1rem;
  }
}
</style>
